import React, { useEffect, useRef } from "react";
import { useLoadScript } from "@react-google-maps/api";

const libraries: Array<"drawing" | "places" | "geometry"> = ["places"];

const AutoComplete = ({
  placeholder,
  setData,
}: {
  placeholder: string;
  setData: (data: any) => void;
}) => {
  const inputRef = useRef(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_PLACES_KEY as string,
    libraries,
  });

  const formData = (data: any) => {
    const addressComponents = data?.address_components;

    const componentMap = {
      subPremise: "",
      premise: "",
      street_number: "",
      route: "",
      postal_code: "",
      locality: "",
      administrative_area_level_1: "",
      administrative_area_level_2: "",
      country: "",
      //
      latitude: 0,
      longitude: 0,
      //
      name: "",
    };

    for (const component of addressComponents) {
      const componentType = component.types[0];
      if (componentMap.hasOwnProperty(componentType)) {
        //@ts-ignore
        componentMap[componentType] = component.long_name;
      }
    }

    //
    const latitude = data?.geometry?.location?.lat();
    const longitude = data?.geometry?.location?.lng();

    setData({
      subPremise: componentMap.subPremise,
      premise: componentMap.premise,
      street_number: componentMap.street_number,
      route: componentMap.route,
      postal_code: componentMap.postal_code,
      locality: componentMap.locality,
      administrative_area_level_1: componentMap.administrative_area_level_1,
      administrative_area_level_2: componentMap.administrative_area_level_2,
      country: componentMap.country,
      //
      latitude: latitude,
      longitude: longitude,
      //
      name: (data.name || "").substring(0,20),
    });
  };

  useEffect(() => {
    if (!isLoaded || loadError) return;

    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(48, 2),
      new google.maps.LatLng(49, 3)
    );

    const options = {
      componentRestrictions: { country: "fr" },
      fields: ["address_components", "geometry", "name"],
      bounds: defaultBounds,
    };

    const autocomplete = new google.maps.places.Autocomplete(
      //@ts-ignore
      inputRef.current,
      options
    );
    autocomplete.addListener("place_changed", () =>
      handlePlaceChanged(autocomplete)
    );

    // return () => autocomplete.removeListener("place_changed", handlePlaceChanged);
  }, [isLoaded, loadError]);

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.target as HTMLInputElement;

    setData({ [name]: value });
  };

  //@ts-ignore
  const handlePlaceChanged = async (address) => {
    if (!isLoaded) return;
    const place = address.getPlace();

    if (!place || !place.geometry) {
      setData({});
      return;
    }
    console.log(place);
    formData(place);
  };

  return (
    <div className="flex-1">
      <div className="flex rounded-md border border-dark-500 bg-dark-400">
        {/* <Image
              src={props.iconSrc}
              height={24}
              width={24}
              alt={props.iconAlt || "icon"}
              className="ml-2"
            /> */}
        <input
          className="shad-input border-0 p-2 flex-1"
          ref={inputRef}
          maxLength={255}
          type="text"
          name="address"
          placeholder={placeholder}
          onChange={handleChange}
        />
      </div>
      {/* <p>{JSON.stringify(input)}</p> */}
    </div>
  );
};
export default AutoComplete;
